import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class EventSpeaker extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'EventSpeaker';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            html_content: '',
        }
    }
}

const servicePath = 'f-speaker';
const servicePlugin = makeServicePlugin({
    Model: EventSpeaker,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin